import React from "react";
import SEO from "@/components/SEO";

export default function PoliticaPrivacidadePage() {
  const updated = "Fevereiro de 2026";
  return (
    <div data-testid="page-politica-privacidade">
      <SEO
        title="Política de privacidade"
        description="Como recolhemos, utilizamos e protegemos os seus dados pessoais no website casanoporto.com. RGPD, direitos, cookies e contactos."
        canonical="https://casanoporto.com/politica-de-privacidade"
      />

      <section className="container-cnp pt-14 lg:pt-20 pb-6">
        <div className="max-w-3xl">
          <span className="tag-chip">Legal</span>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl text-stone-900 leading-[1.05] tracking-[-0.02em]">
            Política de privacidade
          </h1>
          <p className="mt-4 text-sm text-stone-500">Última actualização: {updated}</p>
        </div>
      </section>

      <section className="container-cnp pb-24">
        <div className="prose-cnp max-w-3xl">

          <p>
            Levamos a sério a sua privacidade. Esta política explica que dados pessoais recolhemos, para que fim,
            com que fundamento legal, com quem partilhamos e como os pode controlar. Foi elaborada em conformidade
            com o Regulamento Geral de Protecção de Dados (RGPD — Regulamento (UE) 2016/679) e com a legislação
            portuguesa em vigor.
          </p>

          <h2>1. Responsável pelo tratamento</h2>
          <p>
            <strong>Zélia Silva</strong>, consultora imobiliária associada à mediadora{" "}
            <strong>eXp Global Portugal, Lda.</strong> (licença AMI n.º 18470, sede na Praça Marquês de Pombal,
            n.º 14, 1250-162 Lisboa).
          </p>
          <p>
            Contactos:{" "}
            <a href="mailto:zelia.silva@expportugal.com">zelia.silva@expportugal.com</a> · +351 967 155 498.
          </p>

          <h2>2. Dados que recolhemos</h2>
          <p>Consoante a sua interacção com o website, podemos recolher:</p>
          <ul>
            <li>
              <strong>Formulário de contacto</strong>: nome, email, telefone (opcional) e mensagem.
            </li>
            <li>
              <strong>Pedido de avaliação gratuita</strong>: nome, email, telefone, localização e características
              do imóvel a avaliar.
            </li>
            <li>
              <strong>Marcação de reunião / visita</strong>: nome, contacto, data e horário preferido, imóvel de
              interesse.
            </li>
            <li>
              <strong>Subscrição da newsletter</strong>: endereço de email.
            </li>
            <li>
              <strong>Comparador de preços</strong>: zona, tipologia e área do imóvel — sem qualquer dado pessoal
              associado (não guardamos o resultado da estimativa).
            </li>
            <li>
              <strong>Dados técnicos</strong> automáticos: endereço IP, tipo de dispositivo, browser, páginas
              visitadas, tempo de permanência (via Google Analytics, quando activo).
            </li>
            <li>
              <strong>Favoritos</strong>: guardados localmente no seu browser (localStorage), <em>não</em> são
              enviados para os nossos servidores até que decida partilhar a lista.
            </li>
          </ul>

          <h2>3. Fins e fundamentos legais</h2>
          <table>
            <thead>
              <tr><th>Finalidade</th><th>Fundamento (art.º 6.º RGPD)</th></tr>
            </thead>
            <tbody>
              <tr><td>Responder a contactos, pedidos de avaliação e marcações</td><td>Diligências pré-contratuais / consentimento</td></tr>
              <tr><td>Prestar serviços de consultoria e mediação imobiliária</td><td>Execução de contrato</td></tr>
              <tr><td>Envio da newsletter semanal</td><td>Consentimento (revogável a qualquer momento)</td></tr>
              <tr><td>Analítica e melhoria do website</td><td>Interesse legítimo</td></tr>
              <tr><td>Cumprimento de obrigações legais (facturação, IMPIC, branqueamento de capitais)</td><td>Obrigação legal</td></tr>
            </tbody>
          </table>

          <h2>4. Prazos de conservação</h2>
          <ul>
            <li><strong>Contactos e leads sem contratação</strong>: até 24 meses após o último contacto.</li>
            <li><strong>Clientes com serviço prestado</strong>: 10 anos, por imposição fiscal e legal aplicável à mediação imobiliária.</li>
            <li><strong>Newsletter</strong>: até revogação do consentimento (link de cancelamento em cada email).</li>
            <li><strong>Dados técnicos e analítica</strong>: até 26 meses (Google Analytics).</li>
          </ul>

          <h2>5. Com quem partilhamos os dados</h2>
          <p>Os seus dados são partilhados apenas com quem for necessário para lhe prestar o serviço:</p>
          <ul>
            <li>
              <strong>eXp Global Portugal, Lda.</strong> — mediadora imobiliária responsável pelo enquadramento
              legal da actividade.
            </li>
            <li>
              <strong>Prestadores tecnológicos</strong> (encarregados de tratamento com contrato RGPD):
              alojamento e infraestrutura na cloud, <em>Resend</em> (envio de emails da newsletter),{" "}
              <em>Google Analytics</em> (analítica anonimizada).
            </li>
            <li>
              <strong>Entidades públicas</strong>: quando exigido por lei (autoridade tributária, IMPIC, tribunais).
            </li>
          </ul>
          <p>
            <strong>Nunca vendemos dados pessoais a terceiros nem os partilhamos para fins publicitários de outras
            entidades.</strong>
          </p>

          <h2>6. Transferências internacionais</h2>
          <p>
            Alguns dos nossos prestadores (ex: Google, Resend) podem processar dados fora da União Europeia. Nesses
            casos, aplicam-se garantias contratuais adequadas (Cláusulas Contratuais Tipo aprovadas pela Comissão
            Europeia) para assegurar um nível equivalente de protecção.
          </p>

          <h2>7. Os seus direitos</h2>
          <p>Ao abrigo do RGPD, tem direito a, a qualquer momento:</p>
          <ul>
            <li><strong>Acesso</strong>: saber que dados temos sobre si.</li>
            <li><strong>Rectificação</strong>: corrigir dados incorrectos ou desactualizados.</li>
            <li><strong>Apagamento</strong> (&quot;direito ao esquecimento&quot;): pedir a eliminação dos seus dados, salvo se houver obrigação legal de os conservar.</li>
            <li><strong>Portabilidade</strong>: receber os seus dados num formato estruturado.</li>
            <li><strong>Limitação e oposição</strong>: restringir ou opor-se a determinados tratamentos.</li>
            <li><strong>Retirada do consentimento</strong>: sempre que o tratamento se basear em consentimento.</li>
            <li><strong>Não ser sujeito a decisões automatizadas</strong>: não usamos decisões automatizadas nem &quot;profiling&quot; com efeitos jurídicos.</li>
          </ul>
          <p>
            Para exercer estes direitos, contacte-nos por email:{" "}
            <a href="mailto:zelia.silva@expportugal.com">zelia.silva@expportugal.com</a>.
            Se considerar que os seus direitos não foram respeitados, pode apresentar reclamação à{" "}
            <a href="https://www.cnpd.pt" target="_blank" rel="noopener noreferrer">CNPD — Comissão Nacional de Protecção de Dados</a>.
          </p>

          <h2>8. Cookies e tecnologias semelhantes</h2>
          <p>Utilizamos apenas os cookies estritamente necessários e os que autorizar:</p>
          <ul>
            <li><strong>Essenciais</strong>: sessão, autenticação de administrador, favoritos guardados localmente. Não requerem consentimento.</li>
            <li><strong>Analítica</strong>: Google Analytics (anonimizado, sem partilha para publicidade). Requer o seu consentimento e pode ser desactivado no browser.</li>
          </ul>
          <p>
            Não utilizamos cookies publicitários nem de <em>retargeting</em>. Pode gerir ou apagar cookies a
            qualquer momento nas definições do seu browser.
          </p>

          <h2>9. Segurança</h2>
          <p>
            Adoptamos medidas técnicas e organizativas adequadas para proteger os seus dados contra acesso não
            autorizado, perda, alteração ou destruição: comunicações cifradas (HTTPS), autenticação forte no
            back-office, cópias de segurança regulares e acesso restrito a quem prestar os serviços.
          </p>

          <h2>10. Menores</h2>
          <p>
            O website não se destina a menores de 16 anos e não recolhemos intencionalmente dados relativos a
            menores. Se tiver conhecimento de algum caso, contacte-nos para procedermos ao apagamento.
          </p>

          <h2>11. Alterações a esta política</h2>
          <p>
            Podemos actualizar esta política sempre que existam alterações relevantes ao website, aos serviços ou
            à legislação. A data no topo indica sempre a última versão em vigor.
          </p>

          <h2>12. Contacto</h2>
          <p>
            Dúvidas sobre esta política ou sobre o tratamento dos seus dados:{" "}
            <a href="mailto:zelia.silva@expportugal.com">zelia.silva@expportugal.com</a> · +351 967 155 498.
          </p>

          <p className="text-xs text-stone-500 mt-10">
            Este texto tem carácter informativo. Para questões jurídicas específicas relativas ao RGPD, recomenda-se
            aconselhamento de advogado ou DPO.
          </p>
        </div>
      </section>
    </div>
  );
}
